/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import {BaseFieldViewer} from "./BaseFieldViewer";
import autobind from "autobind-decorator";
import {FileUtils} from "../../../Utils";

export class FileSizeFieldViewer extends BaseFieldViewer {
	@autobind
	_render() {
		const {Value} = this.props;

		return Value !== null ? FileUtils.GetFileSize(Value) : 'N/A';
	}
}